<ng-container *transloco="let t;">
    <div class="modal-header">
        <h4 class="modal-title">{{ t('Add company title (Organization modal) - Add company') }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    
    <form [formGroup]="organizationForm" (ngSubmit)="createOrganization()">
        <div class="modal-body">
                <div class="form-group">
                    <label class="form-label" for="name">{{ t('Name field title (Organization modal) - Name') }}</label>
                    <input type="text" class="form-control" formControlName="name" aria-describedby="name" [ngClass]="{ 'is-invalid error': submitted && form.name.errors }" />
                    <div *ngIf="submitted && form.name.errors" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && form.name.errors }">
                        <div *ngIf="form.name.errors.required">{{ t('Field required (form validation) - Field name is required', {
                            fieldName: t('Name field title (Organization modal) - Name')
                        }) }}</div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="form-label" for="reg-no">{{ t('Reg no field title (Organization modal) - Reg no') }}</label>
                    <input type="text" class="form-control" formControlName="register_no" aria-describedby="reg-no" [ngClass]="{ 'is-invalid error': submitted && form.register_no.errors }"/>
                    <div *ngIf="submitted && form.register_no.errors" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && form.register_no.errors }">
                        <div *ngIf="form.register_no.errors.required">{{ t('Field required (form validation) - Field name is required', {
                            fieldName: t('Reg no field title (Organization modal) - Reg no')
                        }) }}</div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="form-label" for="mobile-number">{{ t('Mobile no field title (Organization modal) - Mobile no') }}</label>
                    <input type="text" class="form-control" formControlName="phone" aria-describedby="mobile-number" />
                </div>
                <div class="form-group">
                    <label class="form-label" for="address">{{ t('Address field title (Organization modal) - Address') }}</label>
                    <input type="text" class="form-control" formControlName="address" aria-describedby="address" />
                </div>
                <div class="form-group">
                    <label class="form-label" for="zip-code">{{ t('Zip code field title (Organization modal) - Zip code') }}</label>
                    <input type="text" class="form-control" formControlName="zipcode" aria-describedby="zip-code" />
                </div>
                <div class="form-group">
                    <label class="form-label" for="city">{{ t('City field title (Organization modal) - City') }}</label>
                    <input type="text" class="form-control" formControlName="city" aria-describedby="city" />
                </div>
        </div>
        <div class="modal-footer">
            <button type="reset" class="btn btn-outline-secondary" (click)="closeModal()" rippleEffect>
                {{ t('Organization modal cancel button text (Organization modal) - Cancel') }}
            </button>
            <button type="submit" class="btn btn-success" rippleEffect>
                <span
                *ngIf="loader" class="spinner-border spinner-border-sm me-1"></span> {{ t('Organization modal save button text (Organization modal) - Save') }}
            </button>
        </div>
    </form>
</ng-container>